import React from 'react';
import { getAgents, applyAgent } from '../api';
import { loadAgentsFromLocal, saveAgentsToLocal } from '../utils/storageFallback';

export default function Marketplace({ showToast }) {
  const [agents, setAgents] = React.useState([]);
  React.useEffect(()=>{
    getAgents().then(data => { setAgents(data); saveAgentsToLocal(data); })
      .catch(() => { setAgents(loadAgentsFromLocal()); });
  },[]);

  async function handleApply(a){
    try {
      const res = await applyAgent(a._id);
      setAgents(prev => prev.map(p => p._id===a._id ? res.agent : p));
      showToast(`${a.name} applied`);
    } catch {
      const updated = agents.map(p => p._id===a._id ? {...p, installed:true, installs:(p.installs||0)+1} : p);
      setAgents(updated); saveAgentsToLocal(updated); showToast('Applied locally (offline)');
    }
  }
  // async function handleUninstall(a){
  //   try {
  //     const res = await uninstallAgent(a._id);
  //     setAgents(prev => prev.map(p => p._id===a._id ? res.agent : p));
  //     showToast(`${a.name} uninstalled`);
  //   } catch {
  //     const updated = agents.map(p => p._id===a._id ? {...p, installed:false} : p);
  //     setAgents(updated); saveAgentsToLocal(updated); showToast('Uninstalled locally (offline)');
  //   }
  // }

  return (
    <div className="card">
      <div className="hero-row">
        <div className="hero-left">
          <div className="hero-title">iXES AI Agents – Plug Autonomy into Your IRP</div>
          <div className="hero-subtitle">
            Discover agents that optimise sales, cash, inventory, HR and more.
          </div>
          <div className="filter-row">
            <div className="filter-chip">All</div>
            <div className="filter-chip">CRM</div>
            <div className="filter-chip">Finance</div>
            <div className="filter-chip">Inventory</div>
            <div className="filter-chip">HR</div>
            <div className="filter-chip">Collections</div>
            <div className="filter-chip">Pricing</div>
            <div className="filter-chip">Training</div>
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-illus"></div>
        </div>
      </div>
      <div className="agent-grid">
        <div className="agent-card">
          <div className="agent-name">Collections Optimizer</div>
          <div style={{fontSize:11,opacity:0.8}}>
            Reduce receivable days and prioritise collections.
          </div>
          <div className="agent-tags">
            <div className="agent-tag">Finance</div>
            <div className="agent-tag">CRM</div>
            <div className="agent-tag">Predictive</div>
          </div>
          <div className="agent-footer">
            <div className="rating">⭐ 4.6 · 1.2k</div>
            <button className="btn-primary" onClick={()=>handleApply(agents[0])}>Apply to My IRP</button>
          </div>
        </div>
        <div className="agent-card">
          <div className="agent-name">Smart Inventory Planner</div>
          <div style={{fontSize:11,opacity:0.8}}>
            Reduce stockouts and overstock intelligently.
          </div>
          <div className="agent-tags">
            <div className="agent-tag">Inventory</div>
            <div className="agent-tag">Operations</div>
          </div>
          <div className="agent-footer">
            <div className="rating">⭐ 4.8 · 890</div>
            <button className="btn-primary" onClick={()=>handleApply(agents[1])}>Apply to My IRP</button>
          </div>
        </div>
        <div className="agent-card">
          <div className="agent-name">HR Pulse Agent</div>
          <div style={{fontSize:11,opacity:0.8}}>
            Detect burnout risks and retention opportunities.
          </div>
          <div className="agent-tags">
            <div className="agent-tag">HR</div>
            <div className="agent-tag">People</div>
          </div>
          <div className="agent-footer">
            <div className="rating">⭐ 4.4 · 530</div>
            <button className="btn-primary" onClick={()=>handleApply(agents[2])}>Apply to My IRP</button>
          </div>
        </div>
      </div>
    </div>
  );
}
